export const actionTypes = {
  FAILED: 'setting-reason-block-id/failed',
  LOADING: 'setting-reason-block-id/loading',
  SUCCESS: 'setting-reason-block-id/success',
  FILTER: 'setting-reason-block-id/filter',
  MESSAGE: 'setting-reason-block-id/message',
  FORM: 'setting-reason-block-id/form',
  RESET: 'setting-reason-block-id/reset',
};

export const historyStatus = {
  'Disetujui': 'green',
  'Ditolak': 'red',
};
